import { defineAIProviderManifest } from "../manifest";
import { OPENAI_MODEL_EFFORTS } from "../openai/manifest";

export const manifest = defineAIProviderManifest({
  id: "azure",
  label: "Azure OpenAI",
  description:
    "Connect through Azure OpenAI. Requires a base URL and deployment names.",
  connectorIdentifier: "azureOpenai",
  defaultChatModel: "gpt-5",
  defaultFastModel: "gpt-5-mini",
  defaultChatEffort: "medium",
  modelEfforts: OPENAI_MODEL_EFFORTS,
  configurable: true,
  requiresChatModel: false,
  credentialFields: [
    {
      key: "baseUrl",
      label: "Base URL",
      description: "Required.",
      placeholder: "https://example.openai.azure.com/openai",
      required: true,
    },
    {
      key: "apiKey",
      label: "API key",
      description: "Stored securely on the server.",
      placeholder: "…",
      sensitive: true,
      required: true,
    },
  ],
  packCredentials: (v) => ({
    baseUrl: v.baseUrl?.trim() ?? "",
    apiKey: v.apiKey?.trim() ?? "",
  }),
  unpackCredentials: (row) => ({ baseUrl: row.baseUrl, apiKey: "" }),
  subtitleField: "baseUrl",
  attachmentSupport: {
    documentMediaTypes: ["application/pdf"],
    extensionToMediaType: { pdf: "application/pdf" },
  },
});
